import Navbar from "./Navbar";
import services from "./services.css"
import NavbarMobile from "./NavbarMobile";
import { useState, useEffect } from "react";
import emailjs from '@emailjs/browser';

function Services(){
    const [formData, setFormData] = useState({
        userName: '',
        emailId: '',
        query: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState('');

    // EmailJS configuration - replace with your actual values
    const EMAILJS_CONFIG = {
        SERVICE_ID: process.env.REACT_APP_EMAIL_SERVICE_ID,           // Replace with your actual Service ID
        TEMPLATE_ID: process.env.REACT_APP_EMAIL_TEMPLATE_ID,             // Replace with your actual Template ID  
        PUBLIC_KEY: process.env.REACT_APP_EMAIL_PUBLIC_KEY            // Replace with your actual Public Key
    };

    // Initialize EmailJS when component mounts
    useEffect(() => {
        emailjs.init({
            publicKey: EMAILJS_CONFIG.PUBLIC_KEY,
        });
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const validateForm = () => {
        if (!formData.userName.trim()) {
            setSubmitMessage('Please enter your name');
            return false;
        }
        if (!formData.emailId.trim()) {
            setSubmitMessage('Please enter your email');
            return false;
        }
        if (!/\S+@\S+\.\S+/.test(formData.emailId)) {
            setSubmitMessage('Please enter a valid email address');
            return false;
        }
        if (!formData.query.trim()) {
            setSubmitMessage('Please enter your query');
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validate form
        if (!validateForm()) {
            return;
        }

        // Check if EmailJS is configured
        if (EMAILJS_CONFIG.PUBLIC_KEY === 'YOUR_PUBLIC_KEY') {
            setSubmitMessage('EmailJS is not configured yet. Please add your Service ID, Template ID, and Public Key.');
            return;
        }

        setIsSubmitting(true);
        setSubmitMessage('');

        try {
            // Template parameters matching your EmailJS template variables
            const templateParams = {
                name: formData.userName,        // matches {{name}} in template
                email: formData.emailId,        // matches {{email}} in template  
                message: formData.query,        // matches {{message}} in template
                time: new Date().toLocaleString(), // matches {{time}} in template
            };

            // console.log('Sending email with params:', templateParams);

            // Correct parameter order: serviceID, templateID, templateParams, publicKey
            const result = await emailjs.send(
                EMAILJS_CONFIG.SERVICE_ID,
                EMAILJS_CONFIG.TEMPLATE_ID,
                templateParams,
                EMAILJS_CONFIG.PUBLIC_KEY
            );

            // console.log('EmailJS result:', result);

            if (result.status === 200) {
                setSubmitMessage('Your query has been submitted successfully! We will get back to you soon.');
                setFormData({ userName: '', emailId: '', query: '' });
            } else {
                setSubmitMessage('Failed to send your query. Please try again.');
            }
        } catch (error) {
            console.error('EmailJS error:', error);
            
            // More specific error messages
            if (error.status === 400) {
                setSubmitMessage('Invalid configuration. Please check your EmailJS settings.');
            } else if (error.status === 402) {
                setSubmitMessage('EmailJS quota exceeded. Please check your account.');
            } else if (error.status === 403) {
                setSubmitMessage('EmailJS access denied. Please check your public key.');
            } else {
                setSubmitMessage(`Failed to send query: ${error.text || error.message || 'Unknown error'}`);
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return(
        <>
            <div className="leptop_Nab_services">
                <Navbar />
            </div>
            <div className="mobile_Nab_services">
                <NavbarMobile />
            </div>
            <div className="contact-container">
                <div className="contact-details">
                    <h2>CONTACT US</h2>
                    <p>To purchase the product, please contact us using the details below:</p>
                </div>
                <div className="contact-info">
                    <p>Email Id - agmitratech@gmail.com</p>
                    <p>Mobile Number - +91 81308 28270</p>
                    <p>Address - Plaksha University, Alpha, Sector 101, IT City Rd, Sahibzada Ajit Singh Nagar, Punjab 140306</p>
                </div>
                <div className="contact-form">
                    <h3>ASK US</h3>
                    <form onSubmit={handleSubmit}>
                        <input 
                            type="text" 
                            name="userName"
                            value={formData.userName}
                            onChange={handleChange}
                            placeholder="User Name" 
                            required 
                            disabled={isSubmitting}
                        />
                        <input 
                            type="email" 
                            name="emailId"
                            value={formData.emailId}
                            onChange={handleChange}
                            placeholder="Email Id" 
                            required 
                            disabled={isSubmitting}
                        />
                        <textarea 
                            name="query"
                            value={formData.query}
                            onChange={handleChange}
                            placeholder="Query" 
                            required
                            disabled={isSubmitting}
                        ></textarea>
                        <button 
                            type="submit" 
                            disabled={isSubmitting}
                            style={{
                                opacity: isSubmitting ? 0.6 : 1,
                                cursor: isSubmitting ? 'not-allowed' : 'pointer'
                            }}
                        >
                            {isSubmitting ? 'SENDING...' : 'DONE'}
                        </button>
                    </form>
                    {submitMessage && (
                        <div 
                            className={`submit-message ${
                                submitMessage.includes('successfully') ? 'success' : 'error'
                            }`}
                            style={{
                                marginTop: '15px',
                                padding: '10px',
                                borderRadius: '4px',
                                backgroundColor: submitMessage.includes('successfully') ? '#d4edda' : '#f8d7da',
                                color: submitMessage.includes('successfully') ? '#155724' : '#721c24',
                                border: `1px solid ${submitMessage.includes('successfully') ? '#c3e6cb' : '#f5c6cb'}`
                            }}
                        >
                            {submitMessage}
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default Services;